module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_payment_calculator__;